import instance from './axiosInstance';

export function getAllProductDimenisonList(reqBody, options = {}, http = instance) {
  return http.post('/usage/all-product-dimension', reqBody, options);
}

export function getUsageMetricsData(reqBody, options = {}, http = instance) {
  return http.post('/usage/metrics/usage', reqBody, options);
}

export function getApiUsageMetricsData(reqBody, options = {}, http = instance) {
  return http.post('/usage/metrics/usage', reqBody, options);
}

export function getAppUsageMetricsData(reqBody, options = {}, http = instance) {
  return http.post('/usage/metrics/usage', reqBody, options);
}

export function getCustomerList(options = {}, http = instance) {
  return http.get('/usage/customer-list', options);
}

export function getAppUsageCountData(reqBody, options = {}, http = instance) {
  return http.post('/usage/metrics/usage', reqBody, options);
}

export function getSSDUsageCountData(reqBody, options = {}, http = instance) {
  return http.post('/usage/metrics/usage', reqBody, options);
}

export function getVideoDimensionsUsageCountData(reqBody, options = {}, http = instance) {
  return http.post('/usage/metrics/usage', reqBody, options);
}

// nexa usage summary (totals for the Nexa block in the usage dashboard)
export function getNexaUsageSummary(reqBody, options = {}, http = instance) {
  return http.post('/nexa/usage/summary', reqBody, options);
}

// api usage breakdown (drilldown from "More Info" in API section)
export function getApiUsageBreakdownTimeseries(reqBody, options = {}, http = instance) {
  return http.post('/usage/api-usage-breakdown/timeseries', reqBody, options);
}

export function getApiUsageBreakdownGroupby(reqBody, options = {}, http = instance) {
  return http.post('/usage/api-usage-breakdown/groupby', reqBody, options);
}

// self serve dashboard
export function getCustomerOnboardingTimeline(options = {}, http = instance) {
  return http.get('/usage/self-serve/usage', options);
}
